<template>
  <div class="pop-container" v-show="show">
    <div class="pop-container-mask" @click="_clickMask"></div>
    <div class="pop-container-content">
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean
    }
  },
  data () {
    return {
      isShow: this.show
    }
  },
  mounted () {
  },
  methods: {
    _clickMask () {
      this.$emit('clickMask')
    }
  }
}
</script>
<style lang="stylus">
.pop-container
  display flex
  justify-content center
  align-items center
  position fixed
  top 0
  left 0
  height 100%
  width 100%
  z-index 9
  .pop-container-mask
    position fixed
    top 0
    left 0
    height 100%
    width 100%
    background-color rgba(0, 0, 0, 0.7)
  .pop-container-content
    z-index 2
</style>
